// First: the promise helpers older iPhones lack, before any module that might call them.
import './components/pdf/promise-polyfills';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { installProductLinks } from './design/app/links';
import { installClientReporter } from './lib/clientReport';

/**
 * SPA entry point — T007 mounts the real shell: providers, router, theme and the Georgian message
 * catalogue. Everything below this line is application code; nothing product-specific lives here.
 */
// *(Owner, 2026-10-12)* Before anything renders: the page's own errors reach the server's log, on
// every device, so a failure that happens only in one student's browser can still be diagnosed.
installClientReporter();

// The design pages' links resolve to application addresses. There is no application stylesheet: every
// screen is a design page rendering with the design's own styles only, exactly as `compare.mjs`
// measures them.
installProductLinks();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
